import { ReactNode } from 'react';

import { FeatureFlag } from '@/constants/feature-flags.ts';

import { useFeatureFlag } from '@/hooks/use-feature-flag.ts';

import { FeatureUnavailablePage } from '@/pages/feature-unavailable-page.tsx';

interface Props {
    flag: FeatureFlag;
    featureName: string;
    children: ReactNode;
}

export const FeatureGuard = ({ flag, featureName, children }: Props) => {
    const { value } = useFeatureFlag(flag);

    if (!value) return <FeatureUnavailablePage featureName={featureName} />;

    return <>{children}</>;
};
